import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Col, Image, Typography, Row as AntRow } from 'antd';
import styled, { ITheme } from 'styled-components';
import BigNumber from 'bignumber.js';
import Row from 'src/components/Row';
import { BTNPrimary } from 'src/components/Button';
import { useDispatch } from 'react-redux';
import Loading from 'src/components/Loading';
import Slider from 'react-slick';
import { TOAST_TYPES } from 'src/components/Toast/redux/Toast.action';
import { addToast } from 'src/components/Toast/redux/Toast.service';
import { apiGetInoByStatus } from 'src/modules/Collections/redux/Collections.service';
import { getUpComing } from '../redux/Home.service';
// import BannerUpcoming from './BannerUpcoming';

const { Text } = Typography;

const Section = styled.div`
    width: 100%;
    height: 100%;
    .upcoming-pool {
        margin: 0 auto;
        margin-top: 100px;
        max-width: 1272px;
        .btn-pools {
            display: flex;
            flex-direction: row;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
            position: static;
            width: fit-content;
            height: 40px;
            padding: 0 30px;
            background: rgb(55, 114, 255);
            border-radius: 90px;
            align-self: stretch;
            -webkit-box-flex: 0;
            flex-grow: 0;
            margin-top: 20px;
            font-style: normal;
            font-size: 16px;
            font-weight: 700;
            color: rgb(252, 252, 253);
            cursor: pointer;
        }
        .upcoming-project {
            width: 100%;
            height: 100%;
            margin-top: 40px;
            justify-content: space-between;
        }

        .title-main {
            font-family: 'Orbitron';
            font-style: normal;
            font-weight: 700;
            font-size: 52px;
            line-height: 66px;
            letter-spacing: 0.02em;
            color: ${({ theme }: { theme: ITheme }) => theme.text3};
        }
        .title-sub {
            color: ${({ theme }: { theme: ITheme }) => theme.white};
        }

        .slider-project {
            width: 100%;
            height: 100%;
            .slick-arrow {
                display: block !important;
            }
            .slick-list {
                padding-bottom: 15px;
            }
            .slick-dots {
                bottom: -77px;
                .slider-dot-custom {
                    .slick-active {
                        width: 32px;
                        height: 8px;
                        background: ${({ theme }: { theme: ITheme }) => theme.text2};
                        border-radius: 4px;
                        .slider-dot-custom-item {
                            display: none;
                        }
                    }
                    li {
                        width: 8px;
                        height: 8px;
                        .slider-dot-custom-item {
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            border: 1px solid ${({ theme }: { theme: ITheme }) => theme.text2};
                        }
                    }
                }
            }
        }

        .project {
            margin: 0 auto;
            margin-top: 20px;
            min-width: 405px;
            z-index: 999;
            & ~ .project {
                // margin-left: 24px;
            }
        }

        .project-status {
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: default;
            height: 32px;
            margin: 0;
            width: fit-content;
            min-width: 120px;

            background: ${({ theme }: { theme: ITheme }) => theme.blue1};
        }

        .project-item {
            display: flex;
            flex-direction: column;
            height: 100%;

            background: ${({ theme }: { theme: ITheme }) => theme.background1};
            border-radius: 4px;
            overflow: hidden;
            &:hover {
                box-shadow: 2px 2px 6px rgba(87, 255, 103, 0.3), 2px 2px 20px rgba(87, 255, 103, 0.7);
            }
        }

        .project-item:first-child {
            margin-left: 0;
        }

        .project-item:last-child {
            margin-right: 0;
        }

        .project-cover {
            height: 235px;
            overflow: hidden;
        }

        .project-logo {
            margin-left: 0px;
            margin-top: 0%;
            border: 2px solid ${({ theme }: { theme: ITheme }) => theme.text6};
            border-radius: 50%;
            width: 72px;
            height: 72px;
            overflow: hidden;
        }

        .project-logo .ant-image-img {
            object-fit: cover;
            height: -webkit-fill-available;
        }

        .project-start {
            margin-top: -28px;
            padding-left: 10px;
            padding-right: 10px;
            max-height: 29px;
            background: rgba(87, 255, 103, 0.3);
            backdrop-filter: blur(27.1828px);
            justify-content: space-between;
        }

        .project-start .ant-typography {
            color: ${({ theme }: { theme: ITheme }) => theme.text1};
        }

        .project-start-text {
            flex: 1;
            margin-left: 10px;
        }

        .project-name {
            color: ${({ theme }: { theme: ITheme }) => theme.text7};
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: 0px;
            text-align: left;
        }

        .project-content {
            padding: 10px 20px 20px;
        }

        .project-details {
            justify-content: space-between;
            padding: 10px 0 0;
        }

        .project-text-label {
            color: ${({ theme }: { theme: ITheme }) => theme.dark3};
        }

        .project-text-value {
            color: ${({ theme }: { theme: ITheme }) => theme.text7};
        }

        .hero-content-title {
            color: ${({ theme }: { theme: ITheme }) => theme.text7};
            font-size: 48px;
            line-height: 55px;
            margin-left: 120px;
        }
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        .upcoming-pool {
            margin: 0 auto;
            margin-top: 40px;
            padding: 0 12px;
            max-width: 100%;
            .hero-content-title {
                margin-left: 0;
                text-align: center;
                width: 100%;
            }
            .btn-pools {
                display: flex;
                flex-direction: row;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                padding: 16px 24px;
                position: static;
                width: 100%;
                height: 32px;
                background: rgb(55, 114, 255);
                border-radius: 90px;
                align-self: stretch;
                -webkit-box-flex: 0;
                flex-grow: 0;
                margin-top: 20px;
                font-style: normal;
                font-size: 16px;
                color: rgb(252, 252, 253);
                cursor: pointer;
            }
            .upcoming-project {
                width: 100%;
                margin-top: 30px;
                // justify-content: space-evenly;
            }

            .title-main {
                font-size: 22px;
                line-height: 32px;
            }

            .slider-project {
                width: 100%;
                height: 100%;
                .slick-arrow {
                    display: none !important;
                }
                .slick-list {
                    padding-bottom: 15px;
                }
                .slick-dots {
                    bottom: -30px;
                    .slider-dot-custom {
                        .slick-active {
                            width: 32px;
                            height: 8px;
                            background: ${theme.text2};
                            border-radius: 4px;
                            .slider-dot-custom-item {
                                display: none;
                            }
                        }
                        li {
                            width: 8px;
                            height: 8px;
                            .slider-dot-custom-item {
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                border: 1px solid ${theme.text2};
                            }
                        }
                    }
                }
            }

            .project {
                margin-top: 20px;
                min-width: 97%;
                & ~ .project {
                    // margin-left: 24px;
                }
            }

            .project-status {
                position: absolute;
                top: 15px;
                right: 15px;
                cursor: default;
                height: 32px;
                margin: 0;
                width: fit-content;
                min-width: 120px;
            }

            .project-item {
                display: flex;
                flex-direction: column;
                height: 100%;
                border-radius: 20px;
                overflow: hidden;
            }

            .project-item:first-child {
                margin-left: 0;
            }

            .project-item:last-child {
                margin-right: 0;
            }

            .project-cover {
                max-height: 235px;
                overflow: hidden;
            }

            .project-logo {
                margin-left: 0px;
                margin-top: 0%;
                border-radius: 50%;
                width: 72px;
                height: 72px;
                overflow: hidden;
            }

            .project-logo .ant-image-img {
                object-fit: cover;
                height: -webkit-fill-available;
            }

            .project-start {
                margin-top: -28px;
                padding-left: 10px;
                padding-right: 10px;
                max-height: 29px;
                backdrop-filter: blur(27.1828px);
                justify-content: space-between;
            }

            .project-start .ant-typography {
            }

            .project-start-text {
                flex: 1;
                margin-left: 10px;
            }

            .project-name {
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: 32px;
                letter-spacing: 0px;
                text-align: left;
            }

            .project-content {
                padding: 10px 20px 20px;
            }

            .project-details {
                justify-content: space-between;
                padding: 10px 0 0;
            }

            .project-text-label {
            }

            .project-text-value {
            }
        }
    `}
`;

const Pool = ({ pool, goToPage }: any) => {
    const openTime = new Date(parseInt(pool.OpenTime, 10)).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
    });
    let currency = pool.Network === 'bsc' ? 'bnb' : pool.Network;
    if (pool.ClaimNetwork) {
        currency = pool.ClaimNetwork === 'bsc' ? 'bnb' : pool.ClaimNetwork;
    }

    const totalRaised = new BigNumber(pool.HardCapInWei).div(10 ** pool.TokenDecimals).toString();
    const personalAllocation = new BigNumber(pool.MaxInvestInWei).div(10 ** pool.TokenDecimals).toString();

    return (
        <div className="project-item" onClick={() => goToPage(pool.OpenTime, pool.SocialUrl)}>
            <Image wrapperClassName="project-cover" preview={false} src={pool.Thumb} />
            <Row className="project-start">
                <Image wrapperClassName="project-logo" preview={false} src={pool.LinkLogo} />
                <Text className="fs-suppersmal fw-medium project-start-text">IDO starts on</Text>
                <Text className="fs-suppersmal fw-suppermedium">
                    {pool.OpenTime === '' ? 'To be announced' : openTime}
                </Text>
            </Row>
            <div className="project-content">
                <Row className="project-details">
                    <Text className="project-name">{pool.SaleTitle}</Text>
                    <Image
                        wrapperStyle={{ width: 54 }}
                        preview={false}
                        src={`https://cdn.infinitelaunch.io/statics/${currency}@2x.png`}
                    />
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">$ {pool.TokenSymbol}</Text>
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">Total Raised</Text>
                    <Text className="fs-regular fw-medium project-text-value">
                        {pool.HardCapInWei === ''
                            ? 'To be announced'
                            : `$ ${parseInt(totalRaised, 10).toLocaleString()}`}
                    </Text>
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">Personal Allocation</Text>
                    <Text className="fs-regular fw-medium project-text-value">
                        {pool.MaxInvestInWei === ''
                            ? 'To be announced'
                            : `$ ${parseInt(personalAllocation, 10).toLocaleString()} Max`}
                    </Text>
                </Row>
            </div>

            {/* <BTNPrimary
                className="btn-gradient project-status"
                title="Coming soon"
                onClick={() => {
                    console.log('Current');
                }}
            /> */}
        </div>
    );
};

const PoolIno = ({ pool }: any) => {
    const openTime = new Date(parseInt(pool.OpenTime, 10)).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
    });
    let currency = pool.NetworkName === 'bsc' ? 'bnb' : pool.NetworkName;
    const history = useHistory();
    return (
        <div
            className="project-item"
            onClick={() => {
                history.push(`/ino/${pool.Slug}`);
            }}
        >
            <Image wrapperClassName="project-cover" preview={false} src={pool.Thumb} />
            <Row className="project-start">
                <Image wrapperClassName="project-logo" preview={false} src={pool.Logo} />
                <Text className="fs-suppersmal fw-medium project-start-text">INO starts on</Text>
                <Text className="fs-suppersmal fw-suppermedium">
                    {pool.OpenTime === '' ? 'To be announced' : openTime}
                </Text>
            </Row>
            <div className="project-content">
                <Row className="project-details">
                    <Text className="project-name">{pool.SaleTitle}</Text>
                    <Image
                        wrapperStyle={{ width: 54 }}
                        preview={false}
                        src={`https://cdn.infinitelaunch.io/statics/${currency}@2x.png`}
                    />
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">INO</Text>
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">Quantity</Text>
                    <Text className="fs-regular fw-medium project-text-value">
                        {pool.StockLeft === '' ? 'To be announced' : `${pool.StockLeft} NFTs`}
                    </Text>
                </Row>
                <Row className="project-details">
                    <Text className="fs-regular fw-regular project-text-label">Price</Text>
                    <Text className="fs-regular fw-medium project-text-value">
                        {pool.Price === '' ? 'To be announced' : `$${pool.Price}  per NFT`}
                    </Text>
                </Row>
            </div>

            <BTNPrimary
                className="btn-gradient project-status"
                title="Coming soon"
                onClick={() => {
                    console.log('Current');
                }}
            />
        </div>
    );
};

const UpComingPoolV2 = () => {
    const [nextPools, setNextPools] = useState([]);
    const [poolInos, setPoolInos] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const settings: any = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        // autoplay: true,
        cssEase: 'linear',
        appendDots: (dots: any) => (
            <div>
                <ul className="slider-dot-custom"> {dots} </ul>
            </div>
        ),
        customPaging: () => <div className="slider-dot-custom-item" />,
    };
    const getNextPools = async () => {
        try {
            setLoading(true);
            const { Items } = (await getUpComing()) as any;
            const listIno = await apiGetInoByStatus(1); // Next INO
            setPoolInos(listIno?.result?.Items);
            const data: any = Items.sort(
                (a: any, b: any): any =>
                    (a.OpenTime !== '' ? a.OpenTime : Infinity) - (b.OpenTime !== '' ? b.OpenTime : Infinity),
            );
            setNextPools(data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('error: ', error);
        }
    };
    useEffect(() => {
        getNextPools();
    }, []);

    const goToPage = (OpenTime: string, SocialUrl: string) => {
        // if (OpenTime === '') {
        //     dispatch(
        //         addToast({
        //             type: TOAST_TYPES.WAITING,
        //             title: 'Waiting!',
        //             description: 'To be announced',
        //         }),
        //     );
        // } else {
        //     history.push(`/join-ido/${SocialUrl}`);
        // }
        history.push(`/join-ido/${SocialUrl}`);
    };
    return (
        <Section id="upcoming-pool">
            {loading && (
                <div style={{ height: 1000 }}>
                    <Loading />
                </div>
            )}
            {!loading && (nextPools.length !== 0 || poolInos.length !== 0) && (
                <div className="upcoming-pool">
                    <AntRow className="home-section wrap-content-home-section">
                        <Row
                            justify="start"
                            data-aos="fade-down"
                            data-aos-offset="100"
                            data-aos-easing="ease-in-sine"
                            data-aos-duration="500"
                        >
                            <div className="fw-bold hero-content-title">
                                <span className="title-main">Upcoming</span>
                                <span className="title-sub title-main"> Project</span>
                            </div>
                        </Row>
                        {/* <BannerUpcoming /> */}
                        <AntRow
                            className="upcoming-project container"
                            data-aos="fade-up"
                            data-aos-offset="0"
                            data-aos-easing="ease-in-sine"
                            data-aos-duration="500"
                        >
                            <Slider className="slider-project" {...settings}>
                                {nextPools.map((pool: any) => {
                                    return (
                                        <>
                                            <Col key={pool.ID} className="project" xs={20} lg={6}>
                                                <Pool pool={pool} goToPage={goToPage} />
                                            </Col>
                                        </>
                                    );
                                })}
                            </Slider>
                            <Slider className="slider-project" {...settings}>
                                {poolInos.map((pool: any) => {
                                    return (
                                        <>
                                            <Col key={pool.ID} className="project" xs={20} lg={6}>
                                                <PoolIno pool={pool} />
                                            </Col>
                                        </>
                                    );
                                })}
                            </Slider>
                        </AntRow>
                    </AntRow>
                </div>
            )}
        </Section>
    );
};

export default UpComingPoolV2;
